export default {
  cursor: "all-scroll",
  background: "#1562ad",
  paddingLeft: 10,
  borderTopLeftRadius: 4,
  borderTopRightRadius: 4,
  borderBottom: "1px solid #353535",
  paddingTop: 3,
  height: 23,
  fontSize: "13px",
  letterSpacing: "1px",
  color: "white",
  fontWeight: 600,
  whiteSpace: "nowrap"
};
